import PropTypes from 'prop-types';

function CompanyInfo({ tenantName, tenantDomain, tenantId }) {
  return (
    <table style={{ width: '100%' }}>
      <tbody>
        <tr>
          <td>
            <b>Company Name:</b>
          </td>
          <td>{tenantName}</td>
        </tr>
        <tr>
          <td>
            <b>Microsoft Domain:</b>
          </td>
          <td>{tenantDomain}</td>
        </tr>
        <tr>
          <td>
            <b>Microsoft ID:</b>
          </td>
          <td>{tenantId}</td>
        </tr>
      </tbody>
    </table>
  );
}

CompanyInfo.propTypes = {
  tenantName: PropTypes.string,
  tenantDomain: PropTypes.string,
  tenantId: PropTypes.string,
};

export default CompanyInfo;
